import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Phone, Mail, ArrowRight, FileText } from "lucide-react";

export default function FinalCTA() {
  return (
    <section className="relative py-28 lg:py-36 overflow-hidden bg-[#0B2545] text-white" data-testid="final-cta-section">
      <div className="absolute -top-32 -left-32 w-[600px] h-[600px] rounded-full bg-[#16A34A]/25 blur-[120px] pointer-events-none" />
      <div className="absolute -bottom-32 -right-32 w-[500px] h-[500px] rounded-full bg-[#16A34A]/20 blur-[120px] pointer-events-none" />

      <div className="container-apex relative">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="max-w-3xl"
        >
          <div className="overline">Ready When You Are</div>
          <h2 className="heading-display text-5xl sm:text-6xl lg:text-7xl mt-5 text-balance">
            Ready to simplify your <span className="text-[#16A34A]">office?</span>
          </h2>
          <p className="mt-6 text-white/70 text-lg max-w-xl">
            Book a <strong className="text-white">FREE</strong> consultation today. We&apos;ll learn your business and outline exactly how Admin Apex can save you time, reduce overhead, and improve productivity.
          </p>
        </motion.div>

        <div className="mt-12 flex flex-wrap items-center gap-4">
          <Link to="/book" data-testid="final-cta-book" className="btn-accent text-base">
            Book Free Consultation <ArrowRight size={16} />
          </Link>
          <a href="tel:+16475107379" data-testid="final-cta-call" className="btn-ghost text-base !text-white !border-white/30 hover:!border-[#16A34A]">
            <Phone size={16} /> Call Us
          </a>
          <a href="mailto:info@adminapex.ca" data-testid="final-cta-email" className="btn-ghost text-base !text-white !border-white/30 hover:!border-[#16A34A]">
            <Mail size={16} /> Email Us
          </a>
          <a href="#contact" data-testid="final-cta-quote" className="btn-ghost text-base !text-white !border-white/30 hover:!border-[#16A34A]">
            <FileText size={16} /> Request a Quote
          </a>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 grid sm:grid-cols-3 gap-6 text-sm">
          <div>
            <div className="text-xs uppercase tracking-widest text-white/40 font-bold">Call</div>
            <a href="tel:+16475107379" className="mt-2 block font-display font-bold text-xl hover:text-[#16A34A]">+1 (647) 510-7379</a>
          </div>
          <div>
            <div className="text-xs uppercase tracking-widest text-white/40 font-bold">Email</div>
            <a href="mailto:info@adminapex.ca" className="mt-2 block font-display font-bold text-xl hover:text-[#16A34A]">info@adminapex.ca</a>
          </div>
          <div>
            <div className="text-xs uppercase tracking-widest text-white/40 font-bold">Visit</div>
            <div className="mt-2 font-display font-bold text-xl">Brampton, Ontario</div>
          </div>
        </div>
      </div>
    </section>
  );
}
